'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _cookie = require('./cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _getApiDomin = require('./getApiDomin');

var _getApiDomin2 = _interopRequireDefault(_getApiDomin);

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//csrf
// 为了解决个别手机，会进入每个页面重新更改tk值，所以在请求接口之前重新给tk赋值
var isWechat = window.navigator.userAgent.indexOf('MicroMessenger') > -1;
var isAndroid444 = window.navigator.userAgent.indexOf('Android 4.4.4') > -1;
var query = Object.assign({}, (0, _utils.entriesToObject)(new URLSearchParams(location.search)), (0, _utils.entriesToObject)(new URLSearchParams(location.hash.split('?')[1])));
var domain = location.host.includes('58') ? '.58.com' : 'zhuanzhuan.com';
var interfaceDomain = location.host.includes('58') ? 'zhuan.58.com' : 'app.zhuanzhuan.com';

function replaceDomain(api) {
  var reg = /(https:|http:)?\/\/(zhuan\.58|app\.zhuanzhuan)\.com/;
  return api.replace(reg, _getApiDomin2.default);
}
function guid() {
  return 'xxxxxxxxxx'.replace(/[x]/g, function (c) {
    var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });
}

function setTk() {
  if (isWechat) {
    if (query.tk) {
      _cookie2.default.set('tk', decodeURIComponent(query.tk), {
        expires: 1000,
        path: '/',
        domain: domain
      });
    } else {
      var cookieid = _cookie2.default.get('tk');
      if (!cookieid) {
        cookieid = 'wx-' + guid();
        _cookie2.default.set('tk', cookieid, { expires: 1000, path: '/', domain: domain });
      }
    }
  }
}
// 拦截器
_axios2.default.interceptors.request.use(function (config) {
  // 每次请求获取最新的TT值
  var TT = _cookie2.default.getPPUObject().TT;
  if (!isAndroid444 && TT) config.headers['Csrf-Token'] = TT; // CSRF防范, 安卓4.4.4不加入此header，否则请求无法发送
  return config;
}, function (error) {
  return Promise.reject(error);
});

_axios2.default.defaults.baseURL = _getApiDomin2.default; //设置默认请求头部，如果开发环境下需要代理，需要把这里注释掉;
var TT = _cookie2.default.getPPUObject().TT;
if (!isAndroid444 && TT) _axios2.default.defaults.headers.common['Csrf-Token'] = TT; //CSRF防范, 安卓4.4.4不加入此header，否则请求无法发送
var get = _axios2.default.get;
/**
 * 对原方法的get做一层装饰，可以传参时不必写params参数，直接传递参数对象，同时对已有的params写法兼容
 * @param args 参数 url config
 * @returns {*}
 */
_axios2.default.get = function () {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  setTk();
  var route = Object.assign({}, (0, _utils.entriesToObject)(new URLSearchParams(location.search)), (0, _utils.entriesToObject)(new URLSearchParams(location.hash.split('?')[1])));
  var param = Object.assign({}, args[1]);
  args[0] = replaceDomain(args[0]);
  //如果以参数方式传递query，同时不存在axios需要的key：params，则为它添加
  if (param && !param.hasOwnProperty('params')) {
    args[1] = {
      params: param
    };
  }
  //如果往后台传递的参数里传了params这个值会出问题， 需要处理，一般传的都是值，所以就判断
  if (param && param.hasOwnProperty('params') && _typeof(param.params) !== 'object') {
    args[1] = {
      params: param
    };
  }

  if (args[1] && args[1].params && _typeof(args[1].params) === 'object') args[1].params = Object.assign({}, { fromChannel: route.fromChannel }, args[1].params);
  return get.apply(undefined, args);
};
var post = _axios2.default.post;
/**
 * axios的post请求默认会依据数据类型设置请求头，但是目前后台应该无法识别json，因此统一将请求的数据设置为x-www-form-urlencoded需要的字符串格式
 * @param args 参数 url data config
 * @returns {*}
 */
_axios2.default.post = function () {
  for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  setTk();
  args[0] = replaceDomain(args[0]);
  var route = Object.assign({}, (0, _utils.entriesToObject)(new URLSearchParams(location.search)), (0, _utils.entriesToObject)(new URLSearchParams(location.hash.split('?')[1])));
  var data = args[1];
  var config = args.length >= 3 && args[2] || {};
  // 判断是字符串 转化成对象
  if (data && typeof data === 'string' && route.fromChannel) data = Object.assign({}, { fromChannel: route.fromChannel }, (0, _utils.entriesToObject)(data));
  // 判断是对象就转化为字符串
  if (data && (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object') {
    var param = Object.assign({}, data);
    // 只有x-www-form-urlencoded 需要qs.stringify, 默认就是x-www-form-urlencoded
    if (!config || !config.headers || !config.headers['content-type'] && !config.headers['Content-Type'] || config.headers['content-type'] === 'application/x-www-form-urlencoded' || config.headers['Content-Type'] === 'application/x-www-form-urlencoded') {
      args[1] = new URLSearchParams(param).toString();
    }
  }
  return post.apply(undefined, args);
};

_axios2.default.jsonp = function () {
  var _arguments = arguments;

  var request = void 0;
  arguments[0] = replaceDomain(arguments[0]);
  switch (arguments.length) {
    case 1:
      request = _axios2.default.get(arguments[0]);
      break;
    case 2:
      if (typeof arguments[1] === 'function') {
        request = _axios2.default.get(arguments[0]).then(function (res) {
          _arguments[1](res.data);
        });
      } else {
        request = _axios2.default.get(arguments[0], { params: arguments[1] });
      }
      break;
    case 3:
      request = _axios2.default.get(arguments[0], { params: arguments[1] }).then(function (res) {
        _arguments[2](res.data);
      });
      break;
    case 4:
      request = _axios2.default.get(arguments[0], { params: arguments[1] }).then(function (res) {
        _arguments[2](res.data);
      }).catch(function (res) {
        _arguments[3](res.data);
      });
      break;
    default:
      request = _axios2.default.get;
  }
  return request;
}; //兼容以前使用jsonp的代码

exports.default = _axios2.default;